const MONTH_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const MONTH_LONG = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export function toDate(value) {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDdMmm(value) {
  const date = toDate(value);
  return date ? `${String(date.getDate()).padStart(2, "0")} ${MONTH_SHORT[date.getMonth()]}` : "";
}

export function formatDateOnly(value) {
  const date = toDate(value);
  return date ? `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}` : "";
}

export function formatDateTime(value) {
  const date = toDate(value);
  if (!date) return "";
  const h = date.getHours();
  const hour12 = h % 12 || 12;
  const ampm = h >= 12 ? "PM" : "AM";
  return `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()} ${String(hour12).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")} ${ampm}`;
}

export function toApiUtcString(value) {
  const date = toDate(value);
  return date ? date.toISOString().replace(/\.\d{3}Z$/, "Z") : null;
}

export function toApiLocalDateTimeWithZ(value) {
  const date = toDate(value);
  if (!date) return null;
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}T${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}Z`;
}

export function isSameDay(a, b) {
  const da = toDate(a);
  const db = toDate(b);
  return !!da && !!db && da.getFullYear() === db.getFullYear() && da.getMonth() === db.getMonth() && da.getDate() === db.getDate();
}

export function daysInMonth(value) {
  const date = toDate(value);
  return date ? new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate() : 0;
}

export { MONTH_LONG };